import { render, staticRenderFns } from "./modalPhotoclaim.pug?vue&type=template&id=75fbebba&lang=pug&"
import script from "./modalPhotoclaim.js?vue&type=script&lang=js&"
export * from "./modalPhotoclaim.js?vue&type=script&lang=js&"
import style0 from "./modalPhotoclaim.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75fbebba')) {
      api.createRecord('75fbebba', component.options)
    } else {
      api.reload('75fbebba', component.options)
    }
    module.hot.accept("./modalPhotoclaim.pug?vue&type=template&id=75fbebba&lang=pug&", function () {
      api.rerender('75fbebba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modalPhotoclaim/index.vue"
export default component.exports